export default function (app) {
  app.controller('klCustomerCenterCancelResellerCtrl', [
    '$state',
    '$window',
    'klSubscriptionService',
    function ($state, $window, SubscriptionService) {
      this.licenseType = $state.params.licenseType;
      this.subscriptionNumber = $state.params.subscriptionNumber;
      this.endDate = $state.params.endDate;

      this.abort = function () {
        $state.go('subscription');
      };

      this.confirm = function () {
        const subscriptionId = $state.params.subscriptionId;

        const onComplete = () =>
          SubscriptionService.cancel(subscriptionId).then(() => $window.location.reload());

        const params = Object.assign({}, $state.params, { onComplete });

        $state.go('subscription.churn-survey', params);
      };
    },
  ]);
}
